import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GenericService } from '../../generic.service';
import { apiResponse } from '../../../models/apiResponse';
import { SuccessfulPurchaseRequest } from '../../../models/payment/successfulPurchaseRequest';
import { SuccessfulPurchaseResponse } from '../../../models/payment/successfulPurchaseResponse';
import { StudentCounsellorRequest } from '../../../models/payment/studentCounsellorRequest';
import { StudentCounsellorResponse } from '../../../models/payment/studentCounsellorResponse';
import { OperationsPersonResponse } from '../../../models/operations/operationsPersonResponse';

@Injectable({
  providedIn: 'root'
})
export class PackagePurchasesService {
  constructor(private genericService: GenericService) { }

  listPackagePurchases(request: SuccessfulPurchaseRequest): Observable<apiResponse<SuccessfulPurchaseResponse[]>> {
    return this.genericService.post('report/package-purchase', request);
  }

  assignCounsellor(request: StudentCounsellorRequest): Observable<StudentCounsellorResponse> {
    return this.genericService.post<StudentCounsellorResponse>('student-counsellor', request);
  }

  updateCounsellor(studentCounsellorId: number, request: StudentCounsellorRequest): Observable<StudentCounsellorResponse> {
    return this.genericService.put<StudentCounsellorResponse>(`student-counsellor/${studentCounsellorId}`, request);
  }

  getOperationsPeople(): Observable<apiResponse<OperationsPersonResponse[]>> {
    return this.genericService.get('operation/people');
  }
}
